// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");
var MultipleChoice$ReactHooksTemplate = require("./MultipleChoice.res.js");
var ToggleMandatory$ReactHooksTemplate = require("./ToggleMandatory.res.js");

function MultipleChoiceEditor(props) {
  var onMultipleChoiceChange = props.onMultipleChoiceChange;
  var multipleChoice = props.multipleChoice;
  var compareChoices = Belt_List.cmpByLength(MultipleChoice$ReactHooksTemplate.nonEmptyChoices(multipleChoice), MultipleChoice$ReactHooksTemplate.choices(multipleChoice));
  var hasInvalidChoice = compareChoices !== 0;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ToggleMandatory$ReactHooksTemplate.make, {
                      mandatory: props.mandatory,
                      onMandatoryChange: props.onMandatoryChange
                    }),
                JsxRuntime.jsx("button", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("img", {
                                    src: Image$ReactHooksTemplate.plusCircle
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: "Add option"
                                  })
                            ],
                            className: "flex items-center justify-between gap-1 text-darkcharcoal"
                          }),
                      className: "bg-ghostwhite border border-gray-400\n            flex rounded p-2 text-sm mt-0" + (
                        hasInvalidChoice ? " disabled-input" : " "
                      ),
                      disabled: hasInvalidChoice,
                      onClick: (function (param) {
                          Curry._1(onMultipleChoiceChange, MultipleChoice$ReactHooksTemplate.setChoices(multipleChoice, Belt_List.concat(MultipleChoice$ReactHooksTemplate.choices(multipleChoice), {
                                        hd: [
                                          RandomId$ReactHooksTemplate.toString(RandomId$ReactHooksTemplate.generate()),
                                          ""
                                        ],
                                        tl: /* [] */0
                                      })));
                        })
                    }),
                JsxRuntime.jsx("div", {
                      children: $$Array.of_list(List.mapi((function (i, param) {
                                  var choice = param[1];
                                  var choiceId = param[0];
                                  return JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("div", {
                                                      children: "Label " + String(i + 1 | 0),
                                                      className: "sb-choice-label text-darkcharcoal text-sm font-medium"
                                                    }),
                                                JsxRuntime.jsx("input", {
                                                      className: (
                                                        choice === "" ? "h-40-px py-2 px-4 rounded bg-white border border-red-500 focus:border-red-500 text-xs w-full" : "h-40-px py-2 px-4 rounded bg-white border border-gray-300 focus:border-gray-600 text-xs w-full"
                                                      ) + " sb-choice-input",
                                                      placeholder: "Enter Label " + String(i + 1 | 0),
                                                      type: "text",
                                                      value: choice,
                                                      onChange: (function ($$event) {
                                                          var value = Utils$ReactHooksTemplate.formTargetValue($$event);
                                                          Curry._1(onMultipleChoiceChange, MultipleChoice$ReactHooksTemplate.setChoices(multipleChoice, List.map((function (choice) {
                                                                          var id = choice[0];
                                                                          if (id === choiceId) {
                                                                            return [
                                                                                    id,
                                                                                    value
                                                                                  ];
                                                                          } else {
                                                                            return choice;
                                                                          }
                                                                        }), MultipleChoice$ReactHooksTemplate.choices(multipleChoice))));
                                                        })
                                                    }),
                                                JsxRuntime.jsx("img", {
                                                      className: "sb-choice-delete h-12-px cursor-pointer",
                                                      src: Image$ReactHooksTemplate.trash,
                                                      onClick: (function (param) {
                                                          Curry._1(onMultipleChoiceChange, MultipleChoice$ReactHooksTemplate.removeChoice(choiceId, MultipleChoice$ReactHooksTemplate.choices(multipleChoice), multipleChoice));
                                                        })
                                                    }),
                                                JsxRuntime.jsx("p", {
                                                      children: "Label can't be blank",
                                                      className: choice === "" ? "sb-choice-error text-red-500 text-xs" : "hidden"
                                                    })
                                              ],
                                              className: "mb-4 sb-choice-row"
                                            }, String(i));
                                }), MultipleChoice$ReactHooksTemplate.choices(multipleChoice))),
                      className: "mb-7 mt-4"
                    })
              ]
            });
}

var make = MultipleChoiceEditor;

exports.make = make;
/* react/jsx-runtime Not a pure module */
